export default __webpack_public_path__ + "static/expa-ai-5709c2f27fd93085d169486ba95f561a.png";